export default __webpack_public_path__ + "static/media/Screenshot_11.cb144c01.png";